import { EldmlTransform } from "./EldmlTransform";
import $ from "jquery";

export class TruncateTransform extends EldmlTransform {
  async apply() {
    // teksty
    const showMorePromise = this.transformer.translate("!@SYS_SHOW_MORE@!");
    const showLessPromise = this.transformer.translate("!@SYS_SHOW_LESS@!");

    const [showMoreText, showLessText] = await Promise.all([
      showMorePromise,
      showLessPromise,
    ]);

    this.selector.find("truncate").each((_, element) => {
      // aktualny tag
      const truncate = $(element);

      // pobieramy atrybuty
      let value = truncate.attr("field-value");
      const heightStr = truncate.attr("height");
      const moreLink = truncate.attr("more-link");

      // kontener na truncate i show more link
      let truncateContainer = $("<div></div>");
      truncateContainer.css("position", "relative");

      // tworzymy nowy div
      let truncateDiv = $("<div class='truncate-element'></div>");

      // wstawiamy HTML do nowego div
      if (value) {
        truncateDiv.html(value);
      }

      // wysokość linii
      const lineHeightStr = $(".truncate-element").css("line-height");
      const lineHeight = lineHeightStr ? parseFloat(lineHeightStr) : 20;

      // liczymy liczbę linii
      const height = heightStr ? parseFloat(heightStr) : undefined;
      const numLines = height ? Math.floor(height / lineHeight) : undefined;

      // ograniczamy wysokość
      if (heightStr) {
        truncateDiv.css("max-height", `${heightStr}px`);
        truncateDiv.css("-webkit-line-clamp", `${numLines}`);
      }

      // dodajemy do kontenera
      truncateContainer.append(truncateDiv);

      // najpierw dodajemy truncateContainer do DOM, aby mieć dostęp do jego wymiarów
      truncate.append(truncateContainer);

      // more link
      if (moreLink !== "true") {
        return;
      }

      // czekamy na przeliczenie rozmiarów
      requestAnimationFrame(() => {
        // sprawdzamy czy potrzebny jest more link
        const isOverflowing =
          truncateDiv[0].scrollHeight > truncateDiv[0].clientHeight;

        if (isOverflowing) {
          truncateContainer.css("padding-bottom", "10px");
          const moreBtn = $("<div class='truncate-more-link'></div>")
            .text(showMoreText)
            .addClass("icon-p24-arrow6-down")
            .on("click", (event) => {
              event.stopPropagation();
              event.preventDefault();

              const maxHeight = truncateDiv.css("max-height");
              if (maxHeight && maxHeight !== "none") {
                truncateDiv.css("max-height", "");
                truncateDiv.css("-webkit-line-clamp", "");
                moreBtn.removeClass("icon-p24-arrow6-down");
                moreBtn.addClass("icon-p24-arrow6-up");
                moreBtn.text(showLessText);
              } else {
                truncateDiv.css("max-height", `${heightStr}px`);
                truncateDiv.css("-webkit-line-clamp", `${numLines}`);
                moreBtn.text(showMoreText);
                moreBtn.removeClass("icon-p24-arrow6-up");
                moreBtn.addClass("icon-p24-arrow6-down");
              }
            });

          // dodajemy do kontenera
          truncateContainer.append(moreBtn);
        }
      });
    });
  }
}
